import '@campact/camper/core/CmprButton.css';
import '@campact/camper/core/CmprFooter';
import '@campact/camper/core/CmprFooterNavigation';
import '@campact/camper/core/CmprFormControl.css';
import '@campact/camper/core/CmprFormHint';
import '@campact/camper/core/CmprFormLabel.css';
import '@campact/camper/core/CmprLogoCampact';
import '@campact/camper/core/CmprResultMessage';
import '@campact/camper/cta/CmprCtaHeader';
import '../modules/piwik_consent_form';
import { installErrorHandler } from '@appsignal/stimulus';
import { Application } from '@hotwired/stimulus';
import appsignal from '../modules/appsignal';
import CaptchaController from './controllers/captcha_controller';
import FormWithCaptchaController from './controllers/form_with_captcha_controller';

import './index.scss';

const application = Application.start();
installErrorHandler(appsignal, application);
application.register('captcha', CaptchaController);
application.register('form-with-captcha', FormWithCaptchaController);
